import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import './CourseTable.css'; // Optional: For custom styles if needed
import plus_icon from "../../../assets/dashboard/plus-icon.svg";
import { getAllCourses } from "../../../services/Trainer/trainer";
import moment from "moment";
import "./Policy.css";
const PolicyTable = ({ courses, onDeleteCourse, onAssignStaff }) => {
  const navigate = useNavigate();

  return (
    <div className="management-container">
      <div className="management-header">
        <h2>Policies</h2>
        {/* <div className="button-group">
                    <button className="export-btn">
                        <i className="bi bi-file-earmark-arrow-down me-2"></i> Export
                    </button>
                    <Link to="add-policy">
                        <button className="add-btn">
                            + Add Policy
                        </button>
                    </Link>
                </div> */}
      </div>

      <div className="table-container">
        <table className="course-table">
          <thead>
            <tr>
              <th colSpan="5">
                <div className="policy-table-header table-header">
                  <div className="cell">Sr #</div>
                  <div className="cell">Policy Title</div>
                  <div className="cell" style={{ textAlign: "center" }}>
                    Approved
                  </div>
                  <div className="cell">Date of upload</div>
                  <div className="cell">Action</div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {courses && courses.length > 0 ? (
              <>
                {courses &&
                  courses.map((course, index) => (
                    <tr key={course._id}>
                      <td colSpan="5">
                        <div className="policy-table-row table-row">
                          <div className="cell">{index + 1}</div>
                          <div className="cell">{course.title}</div>
                          <div className="cell" style={{ textAlign: "center" }}>
                            {course.isApproved ? "YES" : "NO"}
                          </div>
                          <div className="cell">
                            {moment(course?.uploadDate).format("DD-MM-YYYY")}
                          </div>
                          <div className="cell">
                            {/* <button className="action-button"> */}
                            <i
                              className="bi bi-eye"
                              onClick={() => navigate(`${course?._id}`)}
                            ></i>
                            {/* </button> */}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </>
            ) : (
              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px", // Adjust as needed
                  gap: "8px",
                  fontSize: "18px",
                  color: "#666",
                }}
              >
                <i
                  className="bi bi-info-circle"
                  style={{ fontSize: "20px" }}
                ></i>
                No records found
              </div>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PolicyTable;
